<template>
  <div class="page-root">
    <div class="slot-page__head">
      <v-btn icon @click="goBack" title="당근채집으로"><v-icon>mdi-chevron-left</v-icon></v-btn>
      <h1><span class="font-weight-bold">🎰 슬롯머신</span></h1>
    </div>
    <p class="text-caption grey--text mb-6">🥕를 걸고 잭팟에 도전!</p>

    <SlotMachine />
  </div>
</template>

<script>
import SlotMachine from "../../components/SlotMachine.vue";

export default {
  name: "SlotPage",
  components: { SlotMachine },
  methods: {
    goBack() {
      this.$router.push("/currency/gather");
    },
  },
};
</script>

<style scoped>
.page-root {
  padding: 24px 28px;
}
.slot-page__head {
  display: flex;
  align-items: center;
  gap: 6px;
}
</style>
